import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';

class FeatureSectionStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable mainStore;

  @observable isActive = false;

  // 版本情报
  @observable
  activityImgUrl = [
    {
      label: '01',
      image: require('./images/feature_1.png')
    },
    {
      label: '02',
      image: require('./images/feature_1.png')
    },
    {
      label: '03',
      image: require('./images/feature_1.png')
    },
    {
      label: '04',
      image: require('./images/feature_1.png')
    },
    {
      label: '05',
      image: require('./images/feature_1.png')
    }
  ];

  /**
   * 版本情报轮播图
   * @type {BaseSwiperStore}
   */
  featureSwiper = new BaseSwiperStore({
    swiperOptions: {
      centeredSlides: true,
      loop: true,
      loopedSlides: 3,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      effect: 'coverflow',
      coverflowEffect: {
        // 旋转角度
        rotate: 0,
        stretch: Math.min(window.innerWidth * 0.6, 2000),
        depth: Math.min(window.innerWidth * 0.26, 800),
        slideShadows: false
      },
      roundLengths: true,
      watchSlidesProgress: true,
      setWrapperSize: true,
      speed: 600
    }
  });

  /**
   * 调整版本菜单的切换
   * @param index
   */
  onClickChangeSwiper = index => {
    this.featureSwiper.onChange(index);
  };
  /**
   * 点击切换内容轮播图的上一页
   */
  onClickContentGoPrev = () => {
    this.featureSwiper.goPrev();
  };
  /**
   * 点击切换内容轮播图的下一页
   */
  onClickContentGoNext = () => {
    this.featureSwiper.goNext();
  };

  use() {
    super.use();
    useMount(() => {});

    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 5;
        // if (this.isActive) {
        //   this.featureSwiper.onSwiperAutoPlayChange(true);
        // } else {
        //   this.featureSwiper.onSwiperAutoPlayChange(false);
        // }
      },
      [this.mainStore.pageSwiperIndex]
    );
  }
}

export default FeatureSectionStore;
